import { RouterEffects } from './router.effect';

export const effects: any[] = [
    RouterEffects
];
